import { render, staticRenderFns } from "./DueMakeEffectiveStep.vue?vue&type=template&id=706c3dbf&"
import script from "./DueMakeEffectiveStep.vue?vue&type=script&lang=js&"
export * from "./DueMakeEffectiveStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports